import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateRealtyValuationAction, setPriceFilterAction } from '../../../../actions/realtyValuation';
import { Filters, Summaries, TabContent } from '../../../../components/RealtyValuation';
import { TThunkDispatch } from '../../../../types/redux/thunk';
import { getPreparedFiltersProps } from '../../utils/getPreparedFiltersProps';
import { getPriceDiffTitle } from '../../utils/getPriceDiffTitle';
import { PricesChartContainer } from '../PricesChartContainer';
import {
  developerValuationDataFetching,
  developerValuationFiltersState,
  selectDeveloperValuationData,
  selectDeveloperValuationFiltersData,
} from '../../../../selectors/developerValuation';
import { getRegions } from '../../../../selectors/developerV2/getRegions';
import { EmptyContent } from '../../../../components/RealtyValuation/EmptyContent';

export const PricesDynamicsContainer: React.VFC = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  const isFetching = useSelector(developerValuationDataFetching);
  const pricesFiltersState = useSelector(developerValuationFiltersState);
  const pricesFiltersData = useSelector(selectDeveloperValuationFiltersData);
  const realtyValuation = useSelector(selectDeveloperValuationData);
  const regions = useSelector(getRegions);

  const filtersProps = React.useMemo(() => {
    if (!pricesFiltersData) {
      return null;
    }

    return getPreparedFiltersProps({
      onChange: async (filterName, filterValue) => {
        dispatch(setPriceFilterAction({ filterName, filterValue }));
        await dispatch(updateRealtyValuationAction());
      },
      filtersData: pricesFiltersData,
      regions,
    });
    /** Так и должно быть */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, pricesFiltersData, regions]);

  const priceDiffTitle = React.useMemo(() => {
    const { period } = pricesFiltersState;

    return getPriceDiffTitle(period);
  }, [pricesFiltersState]);

  const priceDynamics = realtyValuation?.priceDynamics;

  return (
    <TabContent
      filters={filtersProps && <Filters filtersProps={filtersProps} testId="valuation_prices_filters" />}
      summaries={
        priceDynamics && (
          <Summaries
            avgPrice={priceDynamics.avgPrice || '—'}
            avgPriceSqm={priceDynamics.avgPriceSqm || '—'}
            priceDiff={priceDynamics.priceDiff}
            priceDiffPercent={priceDynamics.priceDiffPercent}
            priceDiffTrend={priceDynamics.priceDiffTrend}
            priceDiffTitle={priceDiffTitle}
          />
        )
      }
      chart={priceDynamics ? <PricesChartContainer /> : <EmptyContent />}
      isFetching={isFetching}
      testId="valuation_prices_tab"
    />
  );
};
